var React = require('react');

function FacebookIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M26.4551 0H1.54492C0.691797 0 0 0.691797 0 1.54492V26.4551C0 27.3082 0.691797 28 1.54492 28H14.957V17.1719H11.3203V12.9336H14.957V9.81367C14.957 6.19609 17.1664 4.22734 20.393 4.22734C21.9379 4.22734 23.2668 4.34219 23.6523 4.39414V8.17578H21.4266C19.6711 8.17578 19.332 9.00977 19.332 10.2348V12.9336H23.5293L22.9824 17.1719H19.332V28H26.4551C27.3082 28 28 27.3082 28 26.4551V1.54492C28 0.691797 27.3082 0 26.4551 0Z"}));
}

FacebookIcon.defaultProps = {"viewBox":"0 0 28 28"};

module.exports = FacebookIcon;

FacebookIcon.default = FacebookIcon;
